import { ModelApiService } from './BaseApiService'

export default class TimesheetsApiService extends ModelApiService {
  constructor() {
    super('timesheets')
  }

  async downloadTimesheetFile(timesheetRecordId) {
    return this.getBlob(`download/${timesheetRecordId}`)
  }
}
